import moment from 'moment';
import { FULL_DATE_FORMAT } from '../constants/date';

export const fromRetentionResult = (result) => {
  const convertUnit = (users, retained) => [users, ...Object.entries(retained).map((e) => e[1])];
  const retentionUnits = result.reduce(
    (a, b) => ({ ...a, [b.date]: convertUnit(b.allUsers, b.retainedUsers) }),
    {}
  );
  return {
    type: 'retentionResult',
    retentionUnits,
  };
};

const dimensionTypes = {
  DAILY: 'day',
  WEEKLY: 'isoWeek',
  MONTHLY: 'month',
};

const getStartOfUnit = (date, unit) =>
  moment(date, FULL_DATE_FORMAT).startOf(unit).format(FULL_DATE_FORMAT);
const getEndOfUnit = (date, unit) =>
  moment(date, FULL_DATE_FORMAT)
    .subtract(1, 'day')
    .add(1, unit)
    .startOf(unit)
    .format(FULL_DATE_FORMAT);

export const toRetentionQuery = (query) => ({
  ...query,
  globalFilter: {
    ...query.globalFilter,
    from: getStartOfUnit(query.globalFilter.from, dimensionTypes[query.sequence.type]),
    to: getEndOfUnit(query.globalFilter.to, dimensionTypes[query.sequence.type]),
  },
});
